import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse } from '@/data/models/ServiceResponse'

export class ValdMeasurementApiService extends ApiService {
  /**
   * Returns list of Vald Measurements
   *
   * @param query
   */
  static async getAll(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('vald-measurements', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }
}
